import { render } from "./ParentTweet.vue?vue&type=template&id=b19fa364&scoped=true"
import script from "./ParentTweet.vue?vue&type=script&lang=js"
export * from "./ParentTweet.vue?vue&type=script&lang=js"

import "./ParentTweet.vue?vue&type=style&index=0&id=b19fa364&lang=scss&scoped=true"

import exportComponent from "/Users/parasagrawal/projects/twitter-helpdesk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19fa364"]])

export default __exports__